import React, { useMemo, useState, FC } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import * as m3u8Parser from 'm3u8-parser';
import videoApi from 'src/api/video';
import { VIDEO_QUALITIES } from 'src/helpers/constants';
import { useRequest } from 'src/helpers/use';
import { swrImmutableOptions } from 'src/helpers/utils';

import { PreviewVideoPlayerStyle } from './style';

import VideoJs from '@components/molecules/videojs';
import { getVideoSetting } from '@helpers/videoSetting';
import { ISubtitle, VideoSetting } from '@interfaces/learning';

export type PreviewVideoPlayerProps = {
  videoUrl: string;
  thumbUrl?: string;
  subtitles?: ISubtitle[];
  className?: string;
};

const PreviewVideoPlayer: FC<PreviewVideoPlayerProps> = ({ videoUrl, thumbUrl, subtitles = [], className = '' }) => {
  const [currentVideoSetting, setCurrentVideoSetting] = useState<VideoSetting>();

  const { data: playlistData } = useRequest<string>(
    videoUrl,
    () => videoApi.fetchPlaylistData(videoUrl),
    swrImmutableOptions,
  );

  const videoQualities = useMemo(() => {
    const qualities: { name: string; url: string }[] = [
      {
        name: VIDEO_QUALITIES.AUTO,
        url: videoUrl,
      },
    ];
    const parser = new m3u8Parser.Parser();
    parser.push(playlistData);
    parser.end();

    parser.manifest?.playlists?.forEach((playlist: { attributes: { NAME: string }; uri: string }) => {
      qualities.push({
        name: playlist.attributes.NAME,
        url: playlist.uri,
      });
    });

    const videoSetting = getVideoSetting();
    if (videoSetting) {
      setCurrentVideoSetting(videoSetting);
    }

    return qualities;
  }, [playlistData, videoUrl]);

  return (
    <PreviewVideoPlayerStyle>
      {videoUrl ? (
        <VideoJs
          thumbUrl={thumbUrl}
          videoUrl={videoUrl}
          subtitles={subtitles}
          videoQualities={videoQualities}
          textTrackLabel={currentVideoSetting?.textTrackLabel}
          volume={currentVideoSetting?.volume}
          quality={currentVideoSetting?.quality}
          isMuted={currentVideoSetting?.isMuted}
          playbackRate={currentVideoSetting?.playbackRate}
          className={className}
        />
      ) : (
        <div className="shimmer-wrapper" />
      )}
    </PreviewVideoPlayerStyle>
  );
};

export default PreviewVideoPlayer;
